import { create } from "zustand";

export type TimeRangeState = {
  start: Date;
  end: Date;
  preset: "1h" | "24h" | "7d" | "custom";
  setPreset: (preset: TimeRangeState["preset"]) => void;
  setRange: (start: Date, end: Date) => void;
};

function fromPreset(preset: TimeRangeState["preset"]): { start: Date; end: Date } {
  const end = new Date();
  const start = new Date(end);
  switch (preset) {
    case "1h":
      start.setHours(start.getHours() - 1);
      break;
    case "24h":
      start.setHours(start.getHours() - 24);
      break;
    case "7d":
      start.setDate(start.getDate() - 7);
      break;
    default:
      start.setHours(start.getHours() - 24);
  }
  return { start, end };
}

export const useTimeRangeStore = create<TimeRangeState>((set) => ({
  ...fromPreset("24h"),
  preset: "24h",
  setPreset: (preset) => {
    if (preset === "custom") {
      set({ preset: "custom" });
      return;
    }
    const { start, end } = fromPreset(preset);
    set({ preset, start, end });
  },
  setRange: (start, end) => set({ start, end, preset: "custom" }),
}));
